module.exports = __webpack_public_path__ + "img/晚安.f1195aa7.png";